import SiteHeader, { MobileSearchBar } from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { newsItems, resources } from "@/mocks/resources";
import HeroSlider from "./components/HeroSlider";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import LatestNews from "./components/LatestNews";
import HotResources from "./components/HotResources";
import TopicCollections from "./components/TopicCollections";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useDocumentMeta(
    "无码 - 高清资源资讯平台，海量内容一站掌握",
    "无码网站聚合丰富的无码资源和最新资讯，涵盖影视、动漫、音乐等多种内容，满足用户多样化需求，轻松获取相关信息。",
    "无码,无码资源,高清无码,无码资讯,无码内容,无码视频,无码下载",
  );

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 pb-24 md:pb-0">
        <section className="wrap pt-6 md:pt-8">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 mb-5 md:mb-6">
            <div className="min-w-0">
              <p className="flex items-center gap-2 text-xs font-medium text-accent-700">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
                </span>
                高清资源资讯 · 影视 / 动漫 / 音乐
              </p>
              <h1 className="mt-2 font-heading font-extrabold text-[26px] md:text-[40px] leading-tight text-foreground-950 tracking-tight">
                无码 · 高清资源资讯平台
              </h1>
              <p className="mt-2.5 text-sm md:text-base text-foreground-600 leading-7 max-w-2xl">
                聚合影视、动漫、音乐三大分类的高清资源资讯，按类型、地区、年份与标签筛选，一次找到想看的内容。
              </p>
            </div>

            <div className="flex items-center gap-6 md:gap-8 shrink-0">
              <div>
                <p className="font-heading font-extrabold text-2xl md:text-3xl text-primary-600">{resources.length}</p>
                <p className="text-xs text-foreground-500 mt-1">精选资源</p>
              </div>
              <div className="w-px h-9 bg-background-300"></div>
              <div>
                <p className="font-heading font-extrabold text-2xl md:text-3xl text-primary-600">3</p>
                <p className="text-xs text-foreground-500 mt-1">内容分类</p>
              </div>
              <div className="w-px h-9 bg-background-300"></div>
              <div>
                <p className="font-heading font-extrabold text-2xl md:text-3xl text-accent-600">{newsItems.length}</p>
                <p className="text-xs text-foreground-500 mt-1">资讯更新</p>
              </div>
            </div>
          </div>

          <HeroSlider />
          <CategoryQuickLinks />
          <LatestNews />
          <HotResources />
          <TopicCollections />
        </section>

        <SiteIntro />
      </main>
      <MobileSearchBar />
      <SiteFooter />
    </div>
  );
}